//shop link https://codesandbox.io/s/vertical-tabs-dg3cq?file=/src/styles.css:0-1144
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import { default as Visibility } from "@material-ui/icons/Visibility";
import clsx from "clsx";
import MaterialTable from "material-table";
import PropTypes from "prop-types";
import React from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	Link,
	Redirect,
	Route,
	Switch,
	useHistory,
	useParams,
	useRouteMatch,
} from "react-router-dom";
import {
	Tab as Tab1,
	TabList as TabList1,
	TabPanel as TabPanel1,
	Tabs as Tabs1,
} from "react-web-tabs";
import { loadShopData } from "../actions/shopLoadData";
import { shopSaveInputsAction } from "../actions/shopSaveCategory";
import App from "../cart/components/App";
import FloatCart from "../cart/components/FloatCart";
import Myorder from "../cart/components/Order/MyOrders";
import { fetchProducts } from "../cart/services/shelf/actions";
import { IP } from "../config/IP";
import store from "../store/createStore";
import ScanBarCode from "./ScanBarCode";
import AddNewProductForm from "./ShopAddNewProductForm";
import ShopAddProductStockForm from "./ShopAddProductStockForm";
import ShopAllocateProductStockForm from "./ShopAllocateProductStockForm";
import "./ShopCategory.css";
import AddNewImageForm from "./ShopUploadImageResizer";

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a12yProps(index, type) {
	return {
		id: `vertical-tab-${index}`,
		"aria-controls": `vertical-tabpanel-${index}`,
	};
}

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
	button: {
		margin: theme.spacing(1),
	},
	fab: {
		position: "absolute",
		bottom: theme.spacing(2),
		right: theme.spacing(2),
	},
	textField: {
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
		width: "25ch",
	},
	wrapper: {
		margin: theme.spacing(1),
		position: "relative",
	},
}));

const CategotyTabs = (props) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const state = useSelector((state) => state);
	const timer = React.useRef();
	const history = useHistory();

	const [value, setValue] = React.useState(0);
	const [loading, setLoading] = React.useState(false);
	const [success, setSuccess] = React.useState(false);
	const [categoryName, setCategoryName] = React.useState("");
	const [subcategoryName, setSubCategoryName] = React.useState("");
	const [dataloading, setDataloading] = React.useState(false);
	const [totalRow, setTotalRow] = React.useState(0);
	const [categoryId, setCategoryId] = React.useState();
	const [addCategoryError, setAddCategoryError] = React.useState(false);
	const [addSubCategoryError, setAddSubCategoryError] = React.useState(false);
	const [tab1Id, setTab1Id] = React.useState("");

	const buttonClassname = clsx({
		[classes.buttonSuccess]: success,
	});
	let match = useRouteMatch();
	const handleSaveNewSubCategory = async () => {
		console.log("handleChangeNewSubCategory subCategoryName=", subcategoryName);
		let inputs = {
			url: IP.nodeServer + "api/editShopCategoryDetails",
			method: "POST",
			data: [
				{ name: "subCategoryName", value: subcategoryName },
				{ name: "categoryId", value: categoryId },
				{ name: "action", value: "insert_new_subCategory" },
			],
		};

		console.log("handleChangeNewSubCategory inputs=", inputs);
		if (subcategoryName) {
			await dispatch(shopSaveInputsAction(inputs));
			setAddSubCategoryError(false);
			inputs = {
				url: IP.nodeServer + "api/loadShopData",
				method: "POST",
				data: [
					{
						name: "companyId",
						value: state.auth.user.allCompanies[0]._id,
					},
				],
			};
			console.log("loadShopData=", inputs);
			await store.dispatch(loadShopData(inputs));
			//window.location="../"
			history.goBack();

			setSuccess(true);
		} else {
			setSuccess(false);
			setAddSubCategoryError(true);
		}
	};

	const handleSaveNewCategory = async () => {
		console.log("handleSaveNewCategory categoryName=", categoryName);
		let inputs = {
			url: IP.nodeServer + "api/createShopCategory",
			method: "POST",
			data: [
				{ name: "categoryName", value: categoryName },
				{
					name: "companyId",
					value: state.companyData.selectedCompanyId,
				},
			],
		};
		if (categoryName) {
			await dispatch(shopSaveInputsAction(inputs));
			setAddCategoryError(false);
			inputs = {
				url: IP.nodeServer + "api/loadShopData",
				method: "POST",
				data: [
					{ name: "companyId", value: state.auth.user.allCompanies[0]._id },
				],
			};
			console.log("loadShopData=", inputs);
			store.dispatch(loadShopData(inputs));
			history.goBack();
			setSuccess(true);
		} else {
			setAddCategoryError(true);
		}
	};
	const handleChangeNewCategory = (e) => {
		console.log("handleSaveNewCategory  e.target.value", e.target.value);
		setCategoryName(e.target.value);
	};
	const handleChangeNewSubCategory = (e) => {
		console.log("handleSaveNewCategory  e.target.value", e.target.value);
		setSubCategoryName(e.target.value);
	};

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	// load new info after saving sub category

	const loadnew = () => {
		setDataloading({
			data: null,

			loading: true,
		});
		try {
			console.log("store.getState().shopData=", store.getState().shopData);
			if (store.getState().shopData.saved) {
				let currentstate = store.getState();

				let response = currentstate.shopData.data;
				console.log("ShopCategory response=", response);
				if (response.data) {
					console.log("axios response=", response);
					let doclist = response.data;
					let docsin = [];
					let respCondition = false;

					let data = [];

					console.log("doclist=", doclist);

					setDataloading({
						data: doclist,

						loading: false,
						total: response.data.total,
						limit: response.data.limit,
						page: response.data.page,
						pages: response.data.pages,
					});
					setTotalRow(response.data.total);
				}
			}
		} catch (e) {
			console.log("ShopCategory error issue=", e);
		}
	};

	const openSubCategoty = (_id) => {
		console.log("openSubCategoty _id=", _id);
		setCategoryId(_id);
		handleChange(this, 1);
	};
	const handleFetchProducts = (filters = props.filters, sort = props.sort) => {
		props.fetchProducts(filters, sort, () => {});
	};
	React.useEffect(() => {
		try {
			let inputs = {
				url: IP.nodeServer + "api/loadShopData",
				method: "POST",
				data: [
					{ name: "companyId", value: state.auth.user.allCompanies[0]._id },
				],
			};
			console.log("loadShopData=", inputs);
			handleFetchProducts();
			dispatch(loadShopData(inputs));
		} catch (e) {}
	}, []);

	// load on any saving
	React.useEffect(() => {
		try {
			if (!state.companyData.isSave) {
				setSuccess(true);
				let inputs = {
					url: IP.nodeServer + "api/loadShopData",
					method: "POST",
					data: [
						{ name: "companyId", value: state.auth.user.allCompanies[0]._id },
					],
				};
				console.log("ShopCategory loadShopData=", inputs);
				dispatch(loadShopData(inputs));
			}
			console.log("state.companyData=", state.companyData);
		} catch (e) {}
	}, [state.companyData.isSave]);
	React.useEffect(() => {
		if (state.shopSaveInfo.isSave) {
			setSuccess(true);
			let inputs = {
				url: IP.nodeServer + "api/loadShopData",
				method: "POST",
				data: [
					{
						name: "companyId",
						value: state.companyData.selectedCompanyId,
					},
				],
			};
			console.log("loadShopData=", inputs);
			dispatch(loadShopData(inputs));
		}
	}, [state.shopSaveInfo.isSave]);

	const Inventory = (prop) => {
		return (
			<>
				<AppBar position="static">
					<Tabs
						value={value}
						onChange={handleChange}
						aria-label="simple tabs example"
					>
						<Tab label="Category" {...a11yProps(0)} />
						<Tab label="Sub Category" {...a11yProps(1)} />
					</Tabs>
				</AppBar>

				<TabPanel value={value} index={0}>
					{dataloading.loading ? (
						"loading"
					) : (
						<div>
							<MaterialTable
								title="Category Table"
								columns={[
									{ title: "categoryId", field: "_id" },
									{ title: "categoryName", field: "categoryName" },
								]}
								data={dataloading.data}
								actions={[
									(rowData) => ({
										icon: () => (
											<Visibility
												color={!rowData.disabled ? "inherit" : "disabled"}
											/>
										),
										tooltip: "view Category",
										onClick: (event, rowData) => openSubCategoty(rowData._id),
									}),
								]}
							/>
						</div>
					)}
					<Link to={`${match.path}/addCategory`}>
						<Fab color="primary" aria-label="add" className={classes.fab}>
							<AddIcon />
						</Fab>
					</Link>
				</TabPanel>
				<TabPanel value={value} index={1}>
					{categoryId ? (
						<ShopSubCategory categoryId={categoryId} />
					) : (
						"no Category selected"
					)}
				</TabPanel>
			</>
		);
	};
	const handleChangeTab1 = (value) => {
		console.log("handleChangeTab1 value=", value);

		setTab1Id(value);
	};

	React.useEffect(() => {
		//console.log("dataloading in data=", data);
		//dispatch(getDocsReq(inputs));
		if (true) {
			loadnew();
		}
	}, [store.getState().shopData.saved]);

	React.useEffect(() => {
		console.log("match.path=", match);
	}, [match.path]);

	return (
		<div className={classes.root}>
			<Switch>
				<Route
					path={`/Shop/ProductImages/:categoryId/:subCategoryId/:productId/`}
				>
					<ProductImages />
				</Route>
				<Route path={`${match.path}/Products/:categoryId/:subCategoryId/`}>
					<Products categoryId={categoryId} />
				</Route>

				<Route path={`${match.path}/addCategory`}>
					<Link to={`${match.path}/`}>
						<ArrowBackIcon />
					</Link>
					<Box>
						add a new category
						<TextField
							error={addCategoryError}
							id="standard-full-width"
							label="Category Name"
							style={{ margin: 8 }}
							placeholder="Category Name"
							helperText="Name of the new Category,should not exceed 50 characters"
							fullWidth
							margin="normal"
							InputLabelProps={{
								shrink: true,
							}}
							onChange={handleChangeNewCategory}
						/>
						<div className={classes.wrapper}>
							<Fab
								aria-label="save"
								color="primary"
								className={buttonClassname}
								onClick={handleSaveNewCategory}
							>
								{success ? <SaveIcon /> : <SaveIcon />}
							</Fab>
							{state.shopSaveInfo.isSaving && (
								<CircularProgress size={68} className={classes.fabProgress} />
							)}
						</div>
					</Box>
				</Route>
				<Route path={`${match.path}/addSubCategory`}>
					{categoryId ? (
						<>
							<Link to={`${match.path}/`}>
								<ArrowBackIcon />
							</Link>
							<Box>
								add a new Sub Category
								<TextField
									error={addSubCategoryError}
									id="standard-full-width"
									label="subCategory Name"
									style={{ margin: 8 }}
									placeholder="subCategory Name"
									helperText="Name of the new sub Category,should not exceed 50 characters"
									fullWidth
									margin="normal"
									InputLabelProps={{
										shrink: true,
									}}
									onChange={handleChangeNewSubCategory}
								/>
								<div className={classes.wrapper}>
									<Fab
										aria-label="save"
										color="primary"
										className={buttonClassname}
										onClick={handleSaveNewSubCategory}
									>
										{success ? <SaveIcon /> : <SaveIcon />}
									</Fab>
									{loading && (
										<CircularProgress
											size={68}
											className={classes.fabProgress}
										/>
									)}
								</div>
							</Box>
						</>
					) : (
						<Redirect
							to={{
								pathname: `${match.path}/`,
								state: { from: `${match.path}/` },
							}}
						/>
					)}
				</Route>
				<Route path={match.path}>
					<Tabs1
						defaultTab="vertical-tab-one"
						vertical
						onChange={(tabId) => handleChangeTab1(tabId)}
					>
						<TabList1>
							<Tab1 tabFor="vertical-tab-one">Shop</Tab1>
							<Tab1 tabFor="vertical-tab-two">My Order</Tab1>
							<Tab1 tabFor="vertical-tab-three">Manage</Tab1>
							<Tab1 tabFor="vertical-tab-four">Scan</Tab1>
						</TabList1>
						<TabPanel1 tabId="vertical-tab-one">
							<App />
						</TabPanel1>
						<TabPanel1 tabId="vertical-tab-two">
							My Order
							<Myorder />
						</TabPanel1>
						<TabPanel1 tabId="vertical-tab-three">
							<>
								<AppBar position="static">
									<Tabs
										value={value}
										onChange={handleChange}
										aria-label="simple tabs example"
									>
										<Tab label="Category" {...a11yProps(0)} />
										<Tab label="Sub Category" {...a11yProps(1)} />
									</Tabs>
								</AppBar>

								<TabPanel value={value} index={0}>
									{dataloading.loading ? (
										"loading"
									) : (
										<div>
											<MaterialTable
												title="Category Table"
												columns={[
													{ title: "categoryId", field: "_id" },
													{ title: "categoryName", field: "categoryName" },
												]}
												data={dataloading.data}
												actions={[
													(rowData) => ({
														icon: () => (
															<Visibility
																color={
																	!rowData.disabled ? "inherit" : "disabled"
																}
															/>
														),
														tooltip: "view Category",
														onClick: (event, rowData) =>
															openSubCategoty(rowData._id),
													}),
												]}
											/>
										</div>
									)}
									<Link to={`${match.path}/addCategory`}>
										<Fab
											color="primary"
											aria-label="add"
											className={classes.fab}
										>
											<AddIcon />
										</Fab>
									</Link>
								</TabPanel>
								<TabPanel value={value} index={1}>
									{categoryId ? (
										<ShopSubCategory categoryId={categoryId} />
									) : (
										"no Category selected"
									)}
								</TabPanel>
							</>
						</TabPanel1>
						<TabPanel1 tabId="vertical-tab-four">
							<main>
								Scan QR code
								{tab1Id === "vertical-tab-four" ? <ScanBarCode /> : ""}
							</main>
						</TabPanel1>
					</Tabs1>
				</Route>
			</Switch>
			<FloatCart />
		</div>
	);
};

const ShopSubCategory = (props) => {
	const [dataloading, setDataloading] = React.useState(false);
	const [totalRow, setTotalRow] = React.useState(0);
	const [subCategoryId, setSubCategoryId] = React.useState();
	const state = useSelector((state) => state);

	const classes = useStyles();
	let match = useRouteMatch();
	const loadnew = () => {
		setDataloading({
			data: null,

			loading: true,
		});
		try {
			console.log("store.getState().shopData=", store.getState().shopData);
			if (store.getState().shopData.saved) {
				let currentstate = state;

				let response = currentstate.shopData.data;
				console.log("ShopSubCategory response=", response);
				if (response.data) {
					console.log("axios response=", response);
					console.log(
						"axios response.data.filter((x) => x._id === props.categoryId)=",
						response.data.filter((x) => x._id === props.categoryId)
					);
					let doclist = response.data.filter(
						(x) => x._id === props.categoryId
					)[0].subCategory;
					let docsin = [];
					let respCondition = false;

					let data = [];

					console.log("subShopCategory doclist=", doclist);

					setDataloading({
						data: doclist,
						title: (doclist = response.data.filter(
							(x) => x._id === props.categoryId
						)[0].categoryName),

						loading: false,
						total: response.data.total,
						limit: response.data.limit,
						page: response.data.page,
						pages: response.data.pages,
					});
					setTotalRow(response.data.total);
				}
			}
		} catch (e) {
			console.log("subShopCategory error issue=", e);
		}
	};
	React.useEffect(() => {
		let inputs = {
			url: IP.nodeServer + "api/loadShopData",
			method: "POST",
			data: [
				{
					name: "companyId",
					value: state.companyData.selectedCompanyId,
				},
			],
		};
		console.log("ShopSubCategory loadShopData=", inputs);
		store.dispatch(loadShopData(inputs));
	}, []);

	React.useEffect(() => {
		//console.log("dataloading in data=", data);
		//dispatch(getDocsReq(inputs));
		if (true) {
			loadnew();
		}
	}, [store.getState().shopData.saved]);
	return (
		<Box>
			<Switch>
				<Route path={`${match.path}/`}>
					{dataloading.loading ? (
						"loading"
					) : (
						<MaterialTable
							title={dataloading.title + ">>SubCategories"}
							columns={[
								{ title: "subCategoryId", field: "_id" },
								{ title: "subCategoryName", field: "subCategoryName" },
							]}
							data={dataloading.data}
							actions={[
								(rowData) => ({
									icon: () => (
										<Link
											to={`${match.path}/Products/${props.categoryId}/${rowData._id}/`}
										>
											<Visibility
												color={!rowData.disabled ? "inherit" : "disabled"}
											/>
										</Link>
									),
									tooltip: "view product",
									//onClick: (event, rowData) => openProduct(rowData._id),
								}),
							]}
						/>
					)}
					<Link to={`${match.path}/addSubCategory`}>
						<Fab color="primary" aria-label="add" className={classes.fab}>
							<AddIcon />
						</Fab>
					</Link>
				</Route>
			</Switch>
		</Box>
	);
};

const Products = (props) => {
	let { categoryId, subCategoryId } = useParams();
	const state = useSelector((state) => state);
	console.log("Products params subCategoryId=", subCategoryId);
	console.log("Products props.categoryId=", categoryId);
	const [dataloading, setDataloading] = React.useState(false);
	const [showNewProductForm, setShowNewProductForm] = React.useState(false);
	const [totalRow, setTotalRow] = React.useState(0);
	const [openFormDialog, setOpenFormDialog] = React.useState(false);
	const [productId, setProductId] = React.useState();
	const [title, setTitle] = React.useState("");

	const classes = useStyles();
	let match = useRouteMatch();
	const loadnew = () => {
		setDataloading({
			data: null,

			loading: true,
		});
		try {
			console.log("store.getState().shopData=", store.getState().shopData);
			if (store.getState().shopData.saved) {
				let currentstate = store.getState();

				let response = currentstate.shopData.data;
				console.log("ShopSubCategory response=", response);
				if (response.data) {
					console.log("axios response=", response);
					console.log(
						"axios response.data.filter((x) => x._id === categoryId)=",
						response.data.filter((x) => x._id === categoryId)
					);
					setTitle(
						response.data.filter((x) => x._id === categoryId)[0].categoryName +
							">>" +
							response.data
								.filter((x) => x._id === categoryId)[0]
								.subCategory.filter((x) => x._id === subCategoryId)[0]
								.subCategoryName +
							"-Products Table"
					);
					let doclist = response.data
						.filter((x) => x._id === categoryId)[0]
						.subCategory.filter((x) => x._id === subCategoryId)[0].productItems;
					let docsin = [];
					let respCondition = false;

					let data = [];

					console.log("subShopCategory doclist=", doclist);

					setDataloading({
						data: doclist,
						title: response.data.filter((x) => x._id === categoryId)[0]
							.categoryName,

						loading: false,
						total: response.data.total,
						limit: response.data.limit,
						page: response.data.page,
						pages: response.data.pages,
					});
					setTotalRow(response.data.total);
				}
			}
		} catch (e) {
			console.log("subShopCategory error issue=", e);
		}
	};

	const handleSaveProductAddStock = (data) => {
		let inputs = {
			url: IP.nodeServer + "api/editShopCategoryDetails",
			method: "POST",
			data: data,
		};
		if (true) store.dispatch(shopSaveInputsAction(inputs));
		console.log("handleSaveProductAddStock data=", data);
		console.log("handleSaveProductAddStock inputs=", inputs);
	};
	const handleCloseProductAddStock = () => {
		setOpenFormDialog(false);
	};

	const addProductItem = (value) => {
		console.log("addProductItem value=", value);
		setProductId(value);
		setOpenFormDialog(true);
	};
	const showAddNewProductForm = () => {
		setShowNewProductForm(true);
	};
	const loadingData = () => {
		console.log("Products state.shopSaveInfo", state.shopSaveInfo);
	};
	React.useEffect(() => {
		//console.log("dataloading in data=", data);
		//dispatch(getDocsReq(inputs));
		if (true) {
			loadnew();
		}
	}, [store.getState().shopData.saved]);
	React.useEffect(() => {
		try {
			let inputs = {
				url: IP.nodeServer + "api/loadShopData",
				method: "POST",
				data: [
					{ name: "companyId", value: state.auth.user.allCompanies[0]._id },
				],
			};
			console.log("Products  loadShopData=", inputs);
			store.dispatch(loadShopData(inputs));
		} catch (e) {}
	}, []);
	React.useEffect(() => {
		if (store.getState().shopSaveInfo.isSave) {
			let inputs = {
				url: IP.nodeServer + "api/loadShopData",
				method: "POST",
				data: [
					{
						name: "companyId",
						value: state.companyData.selectedCompanyId,
					},
				],
			};
			console.log("Products loadShopData=", inputs);
			store.dispatch(loadShopData(inputs));
		}
	}, [store.getState().shopSaveInfo.isSave]);
	if (!dataloading.loading)
		console.log("products dataloading.data=", dataloading.data);
	return (
		<Box>
			{showNewProductForm ? (
				<>
					{" "}
					<Button
						onClick={() => {
							setShowNewProductForm(false);
						}}
					>
						<ArrowBackIcon />
					</Button>
					<AddNewProductForm
						categoryId={categoryId}
						subCategoryId={subCategoryId}
					/>
				</>
			) : (
				<Switch>
					<Route path={`/Shop/Products/:categoryId/:subCategoryId/:productId/`}>
						<Link to={`/Shop/Products/${categoryId}/${subCategoryId}/`}>
							<ArrowBackIcon />
						</Link>
						<ProductStock />
					</Route>

					<Route path={`${match.path}/`}>
						<Link to="/Shop/">
							<ArrowBackIcon />
						</Link>
						{false && (
							<>
								<div>{"categoryId=" + categoryId}</div>
								<div>{"subCategoryId=" + subCategoryId}</div>
							</>
						)}
						{dataloading.loading ? (
							"loading"
						) : (
							<MaterialTable
								title={title}
								columns={[
									{ title: "productId", field: "_id" },
									{ title: "productName", field: "productName" },
									{ title: "Total Stock", field: "totalStock" },

									{ title: "images", field: "totalImages" },
									{ title: "saleUnitPrice", field: "saleUnitPrice" },
									{ title: "Currency", field: "currency" },
									{ title: "Measure", field: "measure" },
									{ title: "Discount%", field: "discount" },
									{ title: "DiscountFromDate", field: "discountFromDate" },
									{ title: "DiscountToDate", field: "discountToDate" },

									{ title: "Createdate", field: "createdate" },
									{ title: "CreateUser", field: "CreatorUserId" },
								]}
								data={
									dataloading.data
										? dataloading.data.map((x) => ({
												...x,
												totalStock: (
													<Link
														to={`/Shop/Products/${categoryId}/${subCategoryId}/${x._id}/`}
													>
														<Button
															tooltip="Click view Stock"
															variant="contained"
															color="default"
															className={classes.button}
														>
															{x.stock
																? x.stock.reduce(
																		(a, b) =>
																			parseInt(a) + parseInt(b.quantity),
																		0
																  ) -
																  x.stock.reduce(
																		(z, y) =>
																			z +
																			y.ordered.reduce(
																				(a, b) =>
																					parseInt(a) + parseInt(b.quantity),
																				0
																			),
																		0
																  )
																: ""}
														</Button>
													</Link>
												),
												totalImages: (
													<Link
														to={`/Shop/ProductImages/${categoryId}/${subCategoryId}/${x._id}/`}
													>
														<Button
															tooltip="Click view Images"
															variant="contained"
															color="default"
															className={classes.button}
														>
															{x.images}
														</Button>
													</Link>
												),
										  }))
										: []
								}
								actions={[
									(rowData) => ({
										icon: () => (
											<Button
												variant="contained"
												className={classes.button}
												color={!rowData.disabled ? "default" : "disabled"}
											>
												<AddIcon /> Stock
											</Button>
										),
										tooltip: "Add Item to product",
										onClick: (event, rowData) => addProductItem(rowData._id),
									}),
								]}
							/>
						)}
						<Fab
							color="primary"
							aria-label="add"
							className={classes.fab}
							onClick={showAddNewProductForm}
						>
							<AddIcon />
						</Fab>
						{productId ? (
							<ShopAddProductStockForm
								open={openFormDialog}
								handleClose={handleCloseProductAddStock}
								handleSave={handleSaveProductAddStock}
								data={{
									categoryId: categoryId,
									subCategoryId: subCategoryId,
									productId: productId,
								}}
								loadingData={() => loadingData}
							/>
						) : (
							""
						)}
					</Route>
				</Switch>
			)}
		</Box>
	);
};

const ProductStock = () => {
	let { categoryId, subCategoryId, productId } = useParams();
	const [title, setTitle] = React.useState("");
	const state = useSelector((state) => state);

	console.log();
	console.log("Products params subCategoryId=", subCategoryId);
	console.log("Products props.categoryId=", categoryId);
	const [dataloading, setDataloading] = React.useState(false);
	const [showNewProductForm, setShowNewProductForm] = React.useState(false);
	const [totalRow, setTotalRow] = React.useState(0);
	const [openFormDialog, setOpenFormDialog] = React.useState(false);
	const [openAllocateFormDialog, setOpenAllocateFormDialog] = React.useState(
		false
	);

	const classes = useStyles();
	let match = useRouteMatch();
	const loadnew = () => {
		setDataloading({
			data: null,

			loading: true,
		});
		try {
			console.log("store.getState().shopData=", store.getState().shopData);
			if (store.getState().shopData.saved) {
				let currentstate = store.getState();

				let response = currentstate.shopData.data;
				console.log("ShopSubCategory response=", response);
				if (response.data) {
					console.log("axios response=", response);
					console.log(
						"axios response.data.filter((x) => x._id === categoryId)=",
						response.data.filter((x) => x._id === categoryId)
					);
					setTitle(
						response.data.filter((x) => x._id === categoryId)[0].categoryName +
							">>" +
							response.data
								.filter((x) => x._id === categoryId)[0]
								.subCategory.filter((x) => x._id === subCategoryId)[0]
								.subCategoryName +
							">>" +
							response.data
								.filter((x) => x._id === categoryId)[0]
								.subCategory.filter((x) => x._id === subCategoryId)[0]
								.productItems.filter((x) => x._id === productId)[0]
								.productName +
							"-Stock"
					);
					let doclist = response.data
						.filter((x) => x._id === categoryId)[0]
						.subCategory.filter((x) => x._id === subCategoryId)[0]
						.productItems.filter((x) => x._id === productId)[0].stock;
					let docsin = [];
					let respCondition = false;

					let data = [];

					console.log("subShopCategory doclist=", doclist);

					setDataloading({
						data: doclist,
						title: response.data.filter((x) => x._id === categoryId)[0]
							.categoryName,

						loading: false,
						total: response.data.total,
						limit: response.data.limit,
						page: response.data.page,
						pages: response.data.pages,
					});
					setTotalRow(response.data.total);
				}
			}
		} catch (e) {
			console.log("subShopCategory error issue=", e);
		}
	};

	const handleSaveProductAddStock = (data) => {
		let inputs = {
			url: IP.nodeServer + "api/editShopCategoryDetails",
			method: "POST",
			data: data,
		};
		if (true) store.dispatch(shopSaveInputsAction(inputs));
		console.log("handleSaveProductAddStock data=", data);
		console.log("handleSaveProductAddStock inputs=", inputs);
	};
	const handleCloseProductAddStock = () => {
		setOpenFormDialog(false);
		setOpenAllocateFormDialog(false);
	};

	const addProductItem = (value) => {
		console.log("addProductItem value=", value);

		setOpenFormDialog(true);
	};
	const allocateProductItemToStock = (value) => {
		console.log("allocateProductItemToStock value=", value);

		setOpenAllocateFormDialog(true);
	};
	const showAddNewProductForm = () => {
		setShowNewProductForm(true);
	};
	const loadingData = () => {
		console.log("ShopCategory state.shopSaveInfo", state.shopSaveInfo);
	};
	React.useEffect(() => {
		//console.log("dataloading in data=", data);
		//dispatch(getDocsReq(inputs));
		if (true) {
			loadnew();
		}
	}, [store.getState().shopData.saved]);

	if (!dataloading.loading)
		console.log("products dataloading.data=", dataloading.data);
	return (
		<Box>
			{showNewProductForm ? (
				<>
					{" "}
					<Button
						onClick={() => {
							setShowNewProductForm(false);
						}}
					>
						<ArrowBackIcon />
					</Button>
					<AddNewProductForm
						categoryId={categoryId}
						subCategoryId={subCategoryId}
					/>
				</>
			) : (
				<Switch>
					<Route path={`${match.path}/`}>
						{false && (
							<>
								<div>{"categoryId=" + categoryId}</div>
								<div>{"subCategoryId=" + subCategoryId}</div>
								<div>{"productId=" + productId}</div>
							</>
						)}
						{dataloading.loading ? (
							"loading"
						) : (
							<MaterialTable
								title={title}
								detailPanel={(rowData) => {
									return (
										<ShopAllocateProductStockForm
											data={{
												categoryId: categoryId,
												subCategoryId: subCategoryId,
												productId: productId,
												stockId: rowData._id,
											}}
										/>
									);
								}}
								columns={[
									{ title: "StockId", field: "_id" },
									{ title: "Quantity", field: "quantity" },
									{
										title: "Ordered",
										field: "ordered",
										render: (rowData) =>
											rowData.ordered
												? rowData.ordered.reduce(
														(a, b) => parseInt(a) + parseInt(b.quantity),
														0
												  )
												: 0,
									},
									{ title: "aquisitionDate", field: "aquisitionDate" },
									{
										title: "aquisitionUnitPrice",
										field: "aquisitionUnitPrice",
									},
									{ title: "currency", field: "currency" },
									{ title: "expiryDate", field: "expiryDate" },
									{ title: "CreatorUserId", field: "CreatorUserId" },
									{ title: "createdate", field: "createdate" },
									{ title: "ModificationUserId", field: "ModificationUserId" },
									{ title: "Modificationdate", field: "Modificationdate" },
								]}
								data={dataloading.data}
								actions={[
									(rowData) => ({
										icon: () => (
											<Button
												variant="contained"
												className={classes.button}
												color={!rowData.disabled ? "default" : "disabled"}
											>
												<EditIcon /> Stock
											</Button>
										),
										tooltip: "modyfy this Item of product",
										onClick: (event, rowData) => addProductItem(rowData._id),
									}),
								]}
							/>
						)}

						{productId ? (
							<>
								<ShopAddProductStockForm
									open={openFormDialog}
									handleClose={handleCloseProductAddStock}
									handleSave={handleSaveProductAddStock}
									data={{
										categoryId: categoryId,
										subCategoryId: subCategoryId,
										productId: productId,
									}}
									loadingData={() => loadingData}
								/>
							</>
						) : (
							""
						)}
					</Route>
				</Switch>
			)}
		</Box>
	);
};

const ProductImages = () => {
	let { categoryId, subCategoryId, productId } = useParams();
	const [title, setTitle] = React.useState("");
	const [success, setSuccess] = React.useState(false);
	const state = useSelector((state) => state);

	console.log("ProductImages params subCategoryId=", subCategoryId);
	console.log("ProductImages props.categoryId=", categoryId);
	const [dataloading, setDataloading] = React.useState(false);
	const [showNewImagesForm, setShowNewImagesForm] = React.useState(false);
	const [totalRow, setTotalRow] = React.useState(0);
	const [openFormDialog, setOpenFormDialog] = React.useState(false);

	const [productName, setProductName] = React.useState("");
	const classes = useStyles();
	const buttonClassname = clsx({
		[classes.buttonSuccess]: success,
	});

	let match = useRouteMatch();
	const loadnew = () => {
		setDataloading({
			data: null,

			loading: true,
		});
		try {
			console.log("store.getState().shopData=", store.getState().shopData);
			if (store.getState().shopData.saved) {
				let currentstate = store.getState();

				let response = currentstate.shopData.data;
				console.log("ShopSubCategory response=", response);
				if (response.data) {
					console.log("axios response=", response);
					console.log(
						"axios response.data.filter((x) => x._id === categoryId)=",
						response.data.filter((x) => x._id === categoryId)
					);
					setTitle(
						response.data.filter((x) => x._id === categoryId)[0].categoryName +
							">>" +
							response.data
								.filter((x) => x._id === categoryId)[0]
								.subCategory.filter((x) => x._id === subCategoryId)[0]
								.subCategoryName +
							">>" +
							response.data
								.filter((x) => x._id === categoryId)[0]
								.subCategory.filter((x) => x._id === subCategoryId)[0]
								.productItems.filter((x) => x._id === productId)[0]
								.productName +
							"-Images"
					);
					setProductName(
						response.data
							.filter((x) => x._id === categoryId)[0]
							.subCategory.filter((x) => x._id === subCategoryId)[0]
							.productItems.filter((x) => x._id === productId)[0].productName
					);
					let doclist = response.data
						.filter((x) => x._id === categoryId)[0]
						.subCategory.filter((x) => x._id === subCategoryId)[0]
						.productItems.filter((x) => x._id === productId)[0].images;
					let docsin = [];
					let respCondition = false;

					let data = [];

					console.log("subShopCategory doclist=", doclist);

					setDataloading({
						data: doclist,
						title: response.data.filter((x) => x._id === categoryId)[0]
							.categoryName,

						loading: false,
						total: response.data.total,
						limit: response.data.limit,
						page: response.data.page,
						pages: response.data.pages,
					});
					setTotalRow(response.data.total);
				}
			}
		} catch (e) {
			console.log("subShopCategory error issue=", e);
		}
	};

	const handleSaveProductAddStock = (data) => {
		let inputs = {
			url: IP.nodeServer + "api/editShopCategoryDetails",
			method: "POST",
			data: data,
		};
		if (true) store.dispatch(shopSaveInputsAction(inputs));
		console.log("handleSaveProductAddStock data=", data);
		console.log("handleSaveProductAddStock inputs=", inputs);
	};
	const handleCloseProductAddStock = () => {
		setOpenFormDialog(false);
	};

	const addProductItem = (value) => {
		console.log("addProductItem value=", value);

		setOpenFormDialog(true);
	};
	const handleShowUploadImagesFrom = () => {
		setShowNewImagesForm(true);
	};
	const loadingData = () => {
		console.log("ShopCategory state.shopSaveInfo", state.shopSaveInfo);
	};
	React.useEffect(() => {
		//console.log("dataloading in data=", data);
		//dispatch(getDocsReq(inputs));
		if (true) {
			loadnew();
		}
	}, [store.getState().shopData.saved]);
	if (!dataloading.loading)
		console.log("products dataloading.data=", dataloading.data);
	return (
		<Box>
			<Link to={`/Shop/Products/${categoryId}/${subCategoryId}/`}>
				<ArrowBackIcon />
			</Link>
			{showNewImagesForm ? (
				<></>
			) : (
				<Switch>
					<Route path={`${match.path}/`}>
						{false && (
							<>
								<div>{"categoryId=" + categoryId}</div>
								<div>{"subCategoryId=" + subCategoryId}</div>
							</>
						)}
						<div>{"productId=" + productId}</div>
						Images
						{dataloading.loading ? (
							"loading"
						) : (
							<>
								<AddNewImageForm
									categoryId={categoryId}
									subCategoryId={subCategoryId}
									productId={productId}
									title={title}
									name={productName}
								/>
								<div className={classes.wrapper}></div>
							</>
						)}
						{productId ? (
							<>
								<ShopAddProductStockForm
									open={openFormDialog}
									handleClose={handleCloseProductAddStock}
									handleSave={handleSaveProductAddStock}
									data={{
										categoryId: categoryId,
										subCategoryId: subCategoryId,
										productId: productId,
									}}
									loadingData={() => loadingData}
								/>
							</>
						) : (
							""
						)}
					</Route>
				</Switch>
			)}
		</Box>
	);
};

const mapStateToProps = (state) => {
	console.log("cart state=", state);
	return {
		products: state.shelf.products,
		cartProducts: state.cart.products,
		newProduct: state.cart.productToAdd,
		productToRemove: state.cart.productToRemove,
		cartTotal: state.total.data,

		filters: state.filters.items,
		sort: state.sort.type,
	};
};

export default connect(mapStateToProps, {
	fetchProducts,
})(CategotyTabs);
